import { Helper } from '../Helper';
export class RawIteratorReduceHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.rawIteratorReduceBase({
            each: (innerOptions) => {
                sb.emitOp(node, 'OVER');
                sb.emitSysCall(node, 'Neo.Enumerator.Value');
                sb.emitOp(node, 'ROT');
                sb.emitSysCall(node, 'Neo.Iterator.Key');
                sb.emitOp(node, 'ROT');
                this.each(innerOptions);
            },
        }));
    }
}

//# sourceMappingURL=RawIteratorReduceHelper.js.map
